import React, { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id },
}) {
  const { t } = useTranslation();

  const [selectedOption, setSelectedOption] = useState({ value: "", label: t('texts.list.all') });

  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set()
    preFilteredRows.forEach(row => {
      if (row.values[id] !== null)
        options.add(row.values[id])
      else {
        console.log("Null value in:")
        console.log(row)
      }
    })
    return Array.from(options).sort(function (a, b) { return a.localeCompare(b) })
  }, [id, preFilteredRows])

  var selectOptions = [{ value: "", label: t('texts.list.all') }]
  options.forEach((option, i) => {
    selectOptions.push({ value: option, label: option })
  })

  return (
    <Select
      value={selectedOption}
      onChange={e => {
        setFilter(e.value || undefined)
        setSelectedOption(e)
      }}
      options={selectOptions}
    />
  )
}

export default SelectColumnFilter;